<template>
    <div>
        <v-card elevation="0">
            <v-card-text v-if="posting.hasOwnProperty('offerLetterCandidates') && posting.offerLetterCandidates.length > 0">
                <v-alert border="top" colored-border color="cyan darken-1" elevation="0" outlined icon="mdi-information-outline">
                    {{ posting.offerLetterCandidates.length }} Offer <span v-if="posting.offerLetterCandidates.length == 1">Letter was</span><span v-else>Letters were</span> generated for this posting: <br />
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Employee #</th>
                                <th>Preferred Email</th>
                                <th>Offer Letter Created</th>
                                <!-- <th>Regenerate Letter</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="info in posting.offerLetterCandidates" :key="info.offerLetterID">
                                <td>{{ info.applicant.firstname+" "+info.applicant.lastname }}</td>
                                <td>{{ info.applicant.employeenumber }}</td>
                                <td>{{ info.applicant.preferredemail }}</td>
                                <td>by <b>{{ info.insertedByCommonName }}</b> at <b>{{ convertTime(info.insertedTimestamp) }}</b></td>
                                <!-- <td><v-btn small icon color="#FF8300"><v-icon>mdi-file-document-refresh-outline</v-icon></v-btn></td> -->
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-alert>
            </v-card-text>
            <v-card-text>
                <v-card elevation="0" v-if="!showletterdetails">
                    <v-data-table :headers="headers" :items="applicants" :items-per-page="10" class="elevation-0" :loading="applicantloading" loading-text="Applicant list loading...Please wait" :search="search" no-data-text="No Application received">
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-row>
                                    <v-col cols="6" md="8" sm="12">
                                        <v-text-field dense v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.adoflag="{ item }">
                            <v-icon color="#FB4570" v-if="checkFlagging(item['generalinfo']['id']) == 1">mdi-flag</v-icon>
                            <v-icon  v-else>mdi-flag-outline</v-icon>
                        </template>
                        <template v-slot:item.hrflag="{ item }" v-if="permissions.setHRflag">
                            <v-tooltip bottom v-if="checkHRFlagging(item['generalinfo']['id']) == 1">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="#FB4570"  v-bind="attrs" v-on="on">mdi-flag-variant</v-icon>
                                </template>
                                <span>{{ typeof(flaggingList.find(v=> v.id == item['generalinfo']['id'] && v.type == 'setHRflag')) != 'undefined' ? flaggingList.find(v=> v.id == item['generalinfo']['id'] && v.type == 'setHRflag').comment : '' }}</span>
                            </v-tooltip>
                            <v-icon v-else>mdi-flag-variant-outline</v-icon>
                        </template>
                        <template v-slot:item.phonetext="{ item }">
                            <span>
                                Home:&nbsp;{{ item["phonetext"]["home"] }}<br />
                                Cell:&nbsp;{{ item["phonetext"]["cell"] }}
                            </span>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn icon small color="#21B6A8" @click="selectApplicant(item)"><v-icon>mdi-check-circle-outline</v-icon></v-btn>
                            <span v-if="checkIfLetterGenerated(item.id)" class="text-caption">*Letter previously generated</span>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card elevation="0" v-else>
                    <v-card-actions class="d-flex align-start">
                        <v-btn color="#EF7C8E" outlined @click="selectDifferentApplicant" small>Select Different Applicant</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="5">
                                <v-row dense>
                                    <v-col cols="6">
                                        <b>Selected Applicant:</b><br />{{ selectedApplicant.generalinfo.firstname+" "+selectedApplicant.generalinfo.lastname }}
                                    </v-col>
                                    <v-col cols="6">
                                        <b>Applicant Address:</b> <br />
                                        {{ selectedApplicant["generalinfo"]["address"]["street"] }}<br />
                                        {{ properCapitalizeText(selectedApplicant["generalinfo"]["address"]["city"])+", "+properCapitalizeText(selectedApplicant["generalinfo"]["address"]["province"])+", "+selectedApplicant["generalinfo"]["address"]["postalcode"].toUpperCase() }}
                                    </v-col>
                                    <v-col cols="4">
                                        <b>Applicant Employee Number:</b><br />
                                        <v-text-field dense outlined v-model="selectedApplicant['employment']['employeenumber']" persistent-hint :hint="selectedApplicant['employment']['taught'] == 'Yes'? `Has taught at King's` : `Never taught at King's`"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" v-if="posting['type'] == 'CLUSTER'"><v-icon>mdi-information-outline</v-icon>&nbsp;This is a Cluster posting. Same text will be used for all courses in the posting.</v-col>
                                    <v-col cols="12">
                                        <v-row dense>
                                            <v-col cols="12">
                                                <b>Department/School:</b>&nbsp; {{ posting["subject-resolved"] }}
                                            </v-col>
                                            <v-col cols="12">
                                                <b>Academic Year:</b>&nbsp; {{ resolveGeneralTerm(posting["strm"]) }}
                                            </v-col>
                                            <v-col cols="12" v-for="course in lecturecourses" :key="course.id">
                                                <v-simple-table>
                                                    <tbody>
                                                        <tr class="grey lighten-4">
                                                            <th colspan="2" class="text-center">Course: {{ course["subject-resolved"]+" "+course.catalognbr+" ("+course.classsection+")" }}</th>
                                                        </tr>
                                                        <tr>
                                                            <th style="width: 30;">Course Weight:</th>
                                                            <td><v-text-field v-model="course.weight" hide-details dense outlined class="text-body-2"></v-text-field></td>
                                                        </tr>
                                                        <tr>
                                                            <th style="width: 30%;">Session:</th>
                                                            <td>{{ course["academicterm-letter"] }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th style="width: 30%;">Total Remuneration for Course:</th>
                                                            <td><v-text-field v-model="course.remuneration" hide-details dense outlined prefix="$" class="text-body-2"></v-text-field></td>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="2">Number of Pay Installments: </th>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2">
                                                                <v-textarea rows="3" v-model="course.installments" hide-details dense outlined class="text-body-2"></v-textarea>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th style="width: 30%;">Period of Instruction:</th>
                                                            <td><v-text-field v-model="course.periodofinstruction" hide-details dense outlined class="text-body-2"></v-text-field></td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col cols="7">
                                <v-row>
                                    <v-col cols="4">
                                        <v-menu v-model="letterdatemenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="letterdate" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details dense outlined label="Offer Letter Date"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="letterdate" @input="letterdatemenu = false" color="#333652"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-menu v-model="signbydatemenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="signbydate" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details dense outlined label="Sign By Date"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="signbydate" @input="signbydatemenu = false" color="#333652"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-model="noofdays" hide-details dense outlined label="# of Working Days"></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field v-model="linkCUPELocal5265" hide-details dense outlined label="Link for Collective Agreement"></v-text-field><br />
                                        <v-text-field v-model="linkHRdownloads" hide-details dense outlined label="Link for Citation Canada"></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field v-model="hrrepname" hide-details dense outlined label="HR Representative Name"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="d-flex align-center justify-end">
                                        <v-btn color="#333652" outlined @click="copyAdditionalText('Probationary')" small><v-icon size="small">mdi-content-copy</v-icon>&nbsp;Probationary Text</v-btn>&nbsp;
                                        <v-btn color="#333652" outlined @click="copyAdditionalText('Work Permit')" small><v-icon size="small">mdi-content-copy</v-icon>&nbsp;Work Permit Text</v-btn>
                                        <!--
                                            <v-btn color="#333652" outlined @click="copyAdditionalText('Cluster Hire')" small><v-icon size="small">mdi-content-copy</v-icon>&nbsp;Cluster Hire Text</v-btn>
                                        -->
                                    </v-col>
                                    <v-col cols="12" class="text-right">
                                        *All text in [ ] will be replaced with the input fields. <v-icon size="small" color="orange">mdi-alert</v-icon>&nbsp;Please do not change their orders or remove them!<br />
                                        <v-textarea outlined label="Text that comes after Course information" v-model="lettertext" hide-details :rows="posting['type'] == 'CLUSTER'? 30 : 25" class="text-body-2"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#333652" outlined :loading="offerletterloading" @click="generateOfferLetter">Generate Offer Letter</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>

export default {
    props: {
        posting: {
            required: true
        },
        permissions: {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            lecturecourses: [],
            offerlettersentapplicants: [],
            applicantloading: false, 
            search: '',
            headers: [
                {text: 'ADO', value: 'adoflag'},
                {text: 'First Name', value: 'generalinfo.firstname'},
                {text: 'Last Name', value: 'generalinfo.lastname'},
                {text: 'Email (Preferred)', value: 'emailinUse'},
                {text: 'Phone', value: 'phonetext'},
                {text: 'Legal to Work', value:"legaltowork"},
                {text: 'Select', value:"action"}
            ],
            applicants: [],
            flaggingList: [],
            showletterdetails: false,
            selectedApplicant: {},
            letterdatemenu: false,
            letterdate: new Date().toISOString().split("T")[0],
            lettertext: "",
            signbydatemenu: false,
            signbydate: new Date().toISOString().split("T")[0],
            noofdays: "10",
            linkCUPELocal5265: "https://kings.uwo.ca/sites/2025/assets/files/about/HR/CA-L5265-Kings-University-College-Expiring-2027.pdf",
            linkHRdownloads: "https://app.citationcanada.com/login",
            hrrepname: "",
            offerletterloading: false
        }
    },
    methods: {
        loadTableHeaders(){
            const that = this;

            if(that.permissions.setHRflag == true){
                that.headers = [
                    {text: 'ADO', value: 'adoflag'},
                    {text: 'HR', value: 'hrflag'},
                    {text: 'First Name', value: 'generalinfo.firstname'},
                    {text: 'Last Name', value: 'generalinfo.lastname'},
                    {text: 'Email (Preferred)', value: 'emailinUse'},
                    {text: 'Phone', value: 'phonetext'},
                    {text: 'Legal to Work', value:"legaltowork"},
                    {text: 'Select', value:"action"}
                ]
            }else {
                that.headers = [
                    {text: 'ADO', value: 'adoflag'},
                    {text: 'First Name', value: 'generalinfo.firstname'},
                    {text: 'Last Name', value: 'generalinfo.lastname'},
                    {text: 'Email (Preferred)', value: 'emailinUse'},
                    {text: 'Phone', value: 'phonetext'},
                    {text: 'Legal to Work', value:"legaltowork"},
                    {text: 'Select', value:"action"}
                ]
            }
        },
        closeDialog(){
            this.$emit("reloadEvent");
        },
        convertTime(time){
            let date = new Date(parseFloat(time));

            return date.toDateString()
        },
        createOfferLetterSentList(){
            const that = this;
            that.offerlettersentapplicants = [];

            if(that.posting.hasOwnProperty('offerLetterCandidates')){
                that.posting.offerLetterCandidates.forEach(element => {
                    that.offerlettersentapplicants.push(element["applicant"]["id"])
                });
            }
        },
        checkFlagging(id){
            const that = this;
            let value = 0;

            that.flaggingList.forEach(element => {
                if(element.id == id && element.type == 'setADOflag'){
                   value = element.value;
                }
            });

            return value
        },
        checkHRFlagging(id){
            const that = this;
            let value = 0;

            that.flaggingList.forEach(element => {
                if(element.id == id && element.type == 'setHRflag'){
                   value = element.value;
                }
            });

            return value
        },
        getApplicantList(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getapplications&data={"postings.id": "'+that.posting.id+'"}';
            that.applicantloading = true;
            that.applicants = [];
            that.lecturecourses = [];

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            that.applicants = json.data;
                            that.flaggingList = json.flags;
                            that.modifyData();

                            //Processing course data
                            that.posting.courses.forEach(element => {
                                if(element.ssrcomponent == 'LEC'){

                                    if(that.posting.type == "CLUSTER"){
                                        element["remuneration"] = that.posting.salary+" inclusive of vacation pay and less applicable deductions";

                                        if(/1/.test(element["sessioncode"]) || /2/.test(element["sessioncode"]) || /6/.test(element["sessioncode"]) || /7/.test(element["sessioncode"])){
                                            element["weight"] = "0.5";
                                        }else {
                                            element["weight"] = "1.0";
                                        }
                                    }else {
                                        if(/1/.test(element["sessioncode"]) || /2/.test(element["sessioncode"]) || /6/.test(element["sessioncode"]) || /7/.test(element["sessioncode"])){
                                            element["weight"] = "0.5";
                                            element["remuneration"] = that.posting.salary[0].halfcourse+" inclusive of vacation pay and less applicable deductions";
                                        }else {
                                            element["weight"] = "1.0";
                                            element["remuneration"] = that.posting.salary[0].fullcourse+" inclusive of vacation pay and less applicable deductions";
                                        }
                                    }

                                    element["installments"] = "monthly, paid on or around the last business day of the month. Vacation pay is included in your total remuneration for this course and will be paid on a monthly basis by direct deposit. Your first payment will be paid on ";
                                    element["periodofinstruction"] = element.instructionstart+" to "+element.instructionend;
                                    element["academicterm-letter"] = element["academicterm"].replace(/[0-9]/g, '');

                                    that.lecturecourses.push(element);
                                }
                            });
                        }
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }

                    that.applicantloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.applicantloading = false;
                })
        },
        modifyData(){
            const that = this;
            that.applicants.forEach(element => {

                //Format Name
                element["generalinfo"]["firstname"] = that.properCapitalizeText(element["generalinfo"]["firstname"]);
                element["generalinfo"]["lastname"] = that.properCapitalizeText(element["generalinfo"]["lastname"]);

                if(element["generalinfo"]["preferredemail"] == "western"){
                    element["emailinUse"] = element["generalinfo"]["westernemail"];
                }else {
                    element["emailinUse"] = element["generalinfo"]["email"];
                }

                element["phonetext"] = element["generalinfo"]["phone"];
            });
        },
        selectApplicant(item){
            const that = this;

            that.selectedApplicant = item;
            that.initializeLetterText();
            that.showletterdetails = true;
        },
        properCapitalizeText(text){
            return text.charAt(0).toUpperCase() + text.slice(1)
        },
        checkIfLetterGenerated(id){
            const that = this;
            
            if(that.offerlettersentapplicants.includes(id)){
                return true
            }else {
                return false
            }
        },
        resolveGeneralTerm(item){
            let term = item.slice(-1);
            if(term == "9"){
                var year = item[1]+item[2];
                var year2 = (parseInt(year)+1).toString();
                var century = (parseInt(item[0])-1).toString();
                return "2"+century+year+"-2"+century+year2;
            }else if(term == "5"){
                var year = item[1]+item[2];
                var year2 = (parseInt(year)-1).toString();
                var century = (parseInt(item[0])-1).toString();
                return "2"+century+year2+"-2"+century+year;
            }

            // var year = item[1]+item[2];
            // var year2 = (parseInt(year)+1).toString();
            // var century = (parseInt(item[0])-1).toString();
            // return "2"+century+year+"-2"+century+year2;
        },
        initializeLetterText(){
            const that = this;
            let text = "";

            text += "On the recommendation of the Chair/Director of the Department/School of " +that.posting["department"]+", "+
                "I am pleased to offer you the following part-time work assignment contract for the following course in the "+that.resolveGeneralTerm(that.posting["strm"])+" Academic Year at King’s University College at Western University:\n[COURSE INFORMATION]\n";
            
            if(that.posting['type'] == 'CLUSTER'){
                text += "This course is part of a multi-section/course position as per the Collective Agreement Article 12.05. Acceptance of this position includes the position in its entirety. "
                    +"Should you be unable/unavailable to teach any aspect of the multi-section/course position, you will be required to relinquish from this position in its entirety. \n\n"
            }

            text += "It is anticipated that you will perform your work onsite at King’s University College, unless otherwise specified by your Supervisor or the mode of delivery of the course. Your anticipated hours of work for this contract are in accordance with the Collective Agreement Article 12.05.\n\n"+ 
                "As a part-time faculty member you are a member of the CUPE Local 5265 Bargaining Unit and are subject to the terms and conditions of the [LINK: Collective Agreement between King’s University College and CUPE Local 5265].\n\n"
            
            if(that.selectedApplicant['employment']['taught'] == 'No'){
                text += "Since you are a new (recently hired) faculty member at King’s you are on probationary contract until you have accumulated two (2.0) full course equivalents as per the Collective Agreement Article 11.05.\n\n"
            }
                
            text += "Your responsibilities include, but are not limited to course preparation/materials; classroom/laboratory instruction; "+
                "setting and marking all graded course components (tests, assignments, etc.); meeting with students (office hours); "+
                "classroom management, proctoring tests/examinations; and the resolution of student appeals related to this work assignment (Article 12.04). "+
                "The carrying out of these responsibilities may need to take place preceding and/or following the period of instruction in matters such as but not limited to preparation of course syllabi, marking and grading of exams and assignments, and fulfilling instructor obligations as set out by university policy related to student appeals and academic offences.\n\n"+
                "You are encouraged to contact your Academic Unit Head to raise any questions you may have related to your teaching responsibilities as noted above and as per Article 12.04 of the Collective Agreement.\n\n"+
                "In accordance with Article 17.05 of the Collective Agreement, you are required to notify your Academic Unit Head as soon as reasonably possible regarding any absence due to illness/injury. "+
                "Wherever possible, you are expected to provide your students with advance notice of such cancellation. Where appropriate, Instructors shall provide any missed course material to the students.\n\n"+
                "[BOLD TEXT: Policies and Guidelines:] In performing your position as an employee of King’s University College, you agree to comply with all applicable policies, guidelines, procedures, rules and regulations. These policies, guidelines, procedures, rules and regulations are subject to change based on the needs of the University. \n\n"+
                "[BOLD TEXT: Confidentiality:] You will also be expected to abide by King’s Confidentiality Agreement.\n\n"+
                "[BOLD TEXT: Required Training:] You will be responsible for completing any training required pursuant to legislation and King’s policy. Required training is available via the following link: [LINK: Citation Canada] \n\n"+
                "Should a work assignment be cancelled after the offer has been made and accepted, but before the first day of classes, a cancellation fee amounting to 10% of the remuneration for this work assignment will be paid to you. "+
                "Should a work assignment be cancelled, on or after the first day of classes, but on or before the official last day to “add” date, a 15% cancellation fee shall be paid to you as per the Collective Agreement Article 12.03.\n\n"+
                "King’s University College is committed to accommodating the needs of our employees with disabilities. If you require accommodation because of a disability or a medical need, please contact hr@kings.uwo.ca so that appropriate arrangements can be made prior to beginning employment. \n\n"+
                "We look forward to your positive response.  Please confirm your acceptance of this assignment by signing and returning one copy of this letter to Human Resources by [TEXT: SIGN BY DATE]. "+
                "This offer letter must be returned within [TEXT: NO WORKING DAYS] working days from the date of this letter. "+
                "This offer is open for acceptance only until the expressed deadline or any extension approved in writing. "+
                "If you have any questions, please do not hesitate to contact [TEXT: HR REP NAME] at hr@kings.uwo.ca or 519-433-3491. Kindly retain a copy of your signed letter for your personal files.";

            that.lettertext = text;
        },
        selectDifferentApplicant(){
            const that = this;
            that.showletterdetails = false;
            that.selectedApplicant = {};
        },
        copyAdditionalText(type){
            const that = this;
            let text = "";

            if(type == "Work Permit"){
                text = "This offer is contingent upon your ability to obtain immigration clearance to work in Canada prior to "+that.posting.startDate
                    +". Your employment with the College is conditional upon satisfactory immigration status maintained for the duration of your appointment. "
                    +"Should you fail to comply with this requirement at any time during the contract period or compromise your legal right to remain or work in Canada in any way, your employment with the College will terminate immediately without notice or pay in lieu. "
                    +"The College will not be responsible for the payment of any further compensation to you. "
                    +"You are obliged to apply for a Social Insurance Number upon arrival in Canada and under government regulations; you must provide the College with this number in order to receive your pay."
            }else if(type == "Cluster Hire"){
                text = "This course is part of a multi-section/course position as per the Collective Agreement Article 12.05. Acceptance of this position includes the position in its entirety. "
                    +"Should you be unable/unavailable to teach any aspect of the multi-section/course position, you will be required to relinquish from this position in its entirety."
            }else if(type == "Probationary"){
                text = "Since you are a new (recently hired) faculty member at King’s you are on probationary contract until you have accumulated two (2.0) full course equivalents as per the Collective Agreement Article 11.05."
            }

            navigator.clipboard.writeText(text);
            that.setSnackbar(type+" text copied to clipboard!", "#05445E"); //orange
        },
        convertDateString(dateString){
            const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            //requested date string format is: Month Date, Year

            return months[parseInt(dateString.split("-")[1])-1]+" "+dateString.split("-")[2]+", "+dateString.split("-")[0];
        },
        generateOfferLetter(){
            const that = this;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            that.offerletterloading = true;

            let letterdata = {
                applicant: {
                    id: that.selectedApplicant["id"],
                    uid: that.selectedApplicant["uid"],
                    firstname: that.selectedApplicant.generalinfo.firstname,
                    lastname: that.selectedApplicant.generalinfo.lastname,
                    address: {
                        street: that.selectedApplicant["generalinfo"]["address"]["street"],
                        city: that.properCapitalizeText(that.selectedApplicant["generalinfo"]["address"]["city"]),
                        province: that.properCapitalizeText(that.selectedApplicant["generalinfo"]["address"]["province"]),
                        postalcode: that.selectedApplicant["generalinfo"]["address"]["postalcode"].toUpperCase()
                    },
                    employeenumber: that.selectedApplicant['employment']['employeenumber'],
                    preferredemail: that.selectedApplicant['emailinUse']
                },
                posting: {
                    id: that.posting.id,
                    courses: that.lecturecourses
                },
                lettervariables: {
                    offerletterdate: that.convertDateString(that.letterdate),
                    department: that.posting["subject-resolved"],
                    academicyear: that.resolveGeneralTerm(that.posting["strm"]),
                    links: {
                        collectiveAgreement: that.linkCUPELocal5265,
                        hrdownloads: that.linkHRdownloads
                    },
                    text: {
                        signbydate: that.convertDateString(that.signbydate),
                        signbydays: that.noofdays,
                        hrrepname: that.hrrepname
                    }
                },
                lettertext: that.lettertext
            }

            const formData = new FormData();

            formData.append("mode", "setofferlettercandidate");
            formData.append("data", JSON.stringify(letterdata));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                        that.offerletterloading = false;
                        that.closeDialog();
                    }else {
                        that.setSnackbar("Offer Letter successfully generated", "#388E3C"); //green
                        that.offerletterloading = false;
                        that.downloadOfferLetter();

                        that.closeDialog();
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.offerletterloading = false;
                    that.closeDialog();
                })
            //End of API calling
        },
        downloadOfferLetter(){
            const that = this;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=downloadofferletter&data={"applicant": {"firstname": "'+that.selectedApplicant.generalinfo.firstname+'", "lastname": "'+that.selectedApplicant.generalinfo.lastname+'"}, "postingid": "'+that.posting.id+'"}';

            fetch(api)
            .then(function(response){
                return response;
            })
            .then(function(data){
                that.setSnackbar("Successful - Download starting", "green");
                window.open(api);
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
            });
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.loadTableHeaders();
        that.getApplicantList();
        that.createOfferLetterSentList();
    }
}
</script>